import React, { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";

interface PopupContextType {
  showPopup: (content: React.ReactNode) => void;
  hidePopup: () => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const PopupProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [open, setOpen] = useState(false);
  const [popupContent, setPopupContent] = useState<React.ReactNode>(null);

  const showPopup = (content: React.ReactNode) => {
    setPopupContent(content);
    setOpen(true);
  };

  const hidePopup = () => {
    setOpen(false);
  };

  return (
    <PopupContext.Provider value={{ showPopup, hidePopup }}>
      {children}

      {/* Global Popup */}
      <Dialog open={open} onClose={hidePopup}>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: "bold",
          }}
        >
          Work in Progress
          <IconButton
            edge="end"
            color="inherit"
            onClick={hidePopup}
            aria-label="close"
            sx={{
              margin: "auto",
              position: "absolute",
              right: "25px",
              top: "17px",

              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "1px solid #fff", // Red border
              color: "#fff", // Default text color
              "&:hover": {
                backgroundColor: "#fff", // Full red background on hover
                color: "#ffffff", // White icon color
              },
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>{popupContent}</DialogContent>
        <DialogActions>
          {/* <Button onClick={hidePopup}>Close</Button> */}
        </DialogActions>
      </Dialog>
    </PopupContext.Provider>
  );
};

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) throw new Error("usePopup must be used within a PopupProvider");
  return context;
};

export default PopupProvider;
